// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__28bT1","header":"ClearentDisclaimer_header__gldF6","inner":"ClearentDisclaimer_inner__th430"};